// 意大利语
import itLocale from 'element-ui/lib/locale/lang/it'


const it = {
  // ============= 登录 start ============
  "验证码": "Codice di verifica",
  "登录": "Accesso",
  "请输入验证码": "Si prega di inserire il codice di verifica",
  "验证码不正确!": "Codice di verifica errato!",
  "请输入账号": "Si prega di inserire il tuo account",
  "请输入密码": "Si prega di inserire la tua password",
  "访问地址有误，请在shop后台核实": "L'indirizzo di accesso è errato, si prega di verificare nel backend del negozio",
  // ============= 登录 end ============

  // ============= Layout start ============
  "全屏模式": "Modalità schermo intero",
  "首页": "Pagina principale",
  "此操作将退出登录, 是否继续?": "Questa operazione disconnetterà, desideri continuare?",
  "已取消退出": "Uscita annullata",
  "您有一个新订单": "Hai un nuovo ordine",
  "无法获取当前门店信息，请重新登录": "Impossibile recuperare le informazioni attuali del negozio, si prega di effettuare nuovamente l'accesso",
  "收银台": "Cassa",
  "收银": "Pagamento",
  "桌台": "Tavolo",
  "订单": "Ordine",
  // ============= Layout end  ============

  // ============= 首页 start ============
  "查询会员": "Ricerca Membro",
  "商品改价": "Modifica Prezzo",
  "商品删行": "Elimina Articolo",
  "整单取消": "Annulla Ordine",
  "挂单": "Tenere Ordine",
  "折扣": "Sconto",
  "抹零": "Arrotondare",
  "请输入内容": "Si prega di inserire il contenuto",
  "收银员": "Cassiere",
  "店内就餐": "Consumo in loco",
  "打包带走": "Asporto",
  "商品名称": "Nome dell'Articolo",
  "商品价格": "Prezzo dell'Articolo",
  "商品数量": "Quantità dell'Articolo",
  "应收": "Totale Pagabile",
  "包装费": "Costo di Imballaggio",
  "优惠": "Sconto",
  "数量": "Quantità",
  "件": "Pezzo",
  "实收": "Importo Ricevuto",
  "收款": "Ricevere Pagamento",
  "请选择商品": "Si prega di selezionare gli articoli",
  "确定要删除": "Sei sicuro di voler eliminare",
  "提示": "Suggerimento",
  "确定": "Confermare",
  "取消": "Annullare",
  "请先将购物车内的商品挂单或结账后再取单": "Si prega di tenere o effettuare il checkout degli articoli nel carrello prima di prendere l'ordine",
  "确定要整单取消吗?": "Sei sicuro di voler annullare l'ordine?",
  "请输入会员手机号查询会员，输入完毕后点击确认": "Si prega di inserire il numero di telefono del membro per cercarlo, quindi fare clic su conferma",
  "请输入会员手机号": "Si prega di inserire il numero di telefono del membro",
  "会员昵称": "Soprannome del Membro",
  "余额总计": "Saldo Totale",
  "退出": "Uscita",
  "该用户不存在": "Questo utente non esiste",
  "折扣抹零": "Sconto/Arrotondamento",
  "当前价格": "Prezzo Attuale",
  "改价": "Modifica Prezzo",
  "实付价格": "Prezzo Effettivo",
  "请输入实付价格": "Si prega di inserire il prezzo effettivo",
  "优惠折扣": "Tasso di Sconto",
  "请输入优惠折扣": "Si prega di inserire il tasso di sconto",
  "抹分": "Arrotondare al Decimo Inferiore",
  "抹角": "Arrotondare al Dollaro Inferiore",
  "四舍五入到角": "Arrotondare al Decimo Più Vicino",
  "四舍五入到元": "Arrotondare al Dollaro Più Vicino",
  "确 定": "Confermare",
  "价格不能为空": "Il prezzo non può essere vuoto",
  "折扣不能为空": "Lo sconto non può essere vuoto",
  "修改价格": "Modifica Prezzo",
  "本次售价": "Prezzo di Vendita Attuale",
  "请输入本次售价": "Si prega di inserire il prezzo di vendita attuale",
  "清空": "Pulire",
  "确认": "Confermare",
  "商品详情": "Dettagli dell'Articolo",
  "单价": "Prezzo Unitario",
  "单位": "Unità",
  "规格": "Specifiche",
  "加料": "Ingredienti Aggiuntivi",
  "取 消": "Annullare",
  "现金收款": "Pagamento in Contanti",
  "余额收款": "Pagamento con Saldo",
  "其他方式": "Altri Metodi",
  "应收金额": "Importo Totale Dovuto",
  "用户通过店内扫码等方式进行支付，确认用户支付成功后，点击确认付款即可完成付款操作。": "I clienti possono pagare utilizzando il codice QR e altri metodi all'interno del negozio. Dopo aver confermato il pagamento riuscito, fare clic su 'Conferma Pagamento' per completare la transazione.",
  "微信支付": "Pagamento WeChat",
  "支付宝支付": "Pagamento Alipay",
  "pos刷卡": "Pagamento con Carta POS",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Si prega di inserire l'ID del membro per cercarlo, quindi fare clic su conferma",
  "请输入会员ID": "Si prega di inserire l'ID del membro",
  "登录会员仅作为积分累计，无法享受其他优惠。": "I membri registrati possono solo accumulare punti e non sono idonei ad altri sconti.",
  "取消收款": "Annulla Pagamento",
  "订单总价": "Prezzo Totale dell'Ordine",
  "挂单时间": "Ora di Tenuta dell'Ordine",
  "删除": "Eliminare",
  "取单": "Prendere Ordine",
  "多语言小票打印": "Stampa Ricevuta Multilingue",
  "打印语言": "Lingua di Stampa",
  "中文": "Cinese",
  "英语": "Inglese",
  "德语": "Tedesco",
  "法语": "Francese",
  "西班牙语": "Spagnolo",
  "意大利语": "Italiano",
  "克罗地亚": "Croato",
  "斯洛文尼亚": "Sloveno",
  "匈牙利语": "Ungherese",
  "塞尔维亚语": "Serbo",
  // ============= 首页 end   ============

  // ============= 桌台 start ============
  "未开台": "Non Aperto",
  "已开台": "Tavolo Aperto",
  "就餐中": "Consumo in Corso",
  "刷新": "Aggiorna",
  "整单清空": "Cancella l'Ordine Intero",
  "转台": "Cambialo",
  "打印预结单": "Stampa Conto Preliminare",
  "催菜": "Sveltire l'Ordine",
  "人数": "Numero di Ospiti",
  "订单来源": "Origine dell'Ordine",
  "请点击左侧桌号台": "Si prega di fare clic sul numero del tavolo sulla sinistra",
  "点选已开台桌台，可以在此查看点餐信息。": "Seleziona un tavolo aperto per visualizzare i dettagli degli ordini qui.",
  "服务费": "Commissione di Servizio",
  "税费": "Tasse",
  "协助点餐": "Assistenza nell'Ordinare",
  "协助加餐": "Assistenza nell'Aggiunta di Articoli",
  "结账": "Pagare",
  "完成": "Completo",
  "价格": "Prezzo",
  "请选择": "Si prega di selezionare",
  "确定要打印小票吗?": "Sei sicuro di voler stampare lo scontrino?",
  "确定要关闭桌台并取消订单吗?": "Sei sicuro di voler chiudere il tavolo e annullare l'ordine?",
  "请选择桌号": "Si prega di selezionare un numero di tavolo",
  "就餐人数": "Numero di Coperti",
  "下单": "Ordinare",
  "返回": "Indietro",
  "确定要商品删行吗?": "Sei sicuro di voler eliminare la riga dell'articolo?",
  "请选择就餐人数": "Si prega di selezionare il numero di coperti",
  // ============= 桌台 end  ============

  // ============= 订单 start ============
  "下单时间": "Ora dell'Ordine",
  "起始时间": "Orario di Inizio",
  "店内订单": "Ordine in Negozio",
  "自提订单": "Ordine da Asporto",
  "外卖订单": "Ordine per la Consegna a Domicilio",
  "名称": "Nome",
  "支付时间": "Orario di Pagamento",
  "消费方式": "Metodo di Pagamento",
  "状态": "Stato",
  "金额": "Importo",
  "税率": "Aliquota Fiscale",
  "税费金额": "Importo delle Tasse",
  "邮箱地址": "Indirizzo Email",
  "今天": "Oggi",
  "昨天": "Ieri",
  "一周": "Una Settimana",
  "搜索": "Ricerca",
  "待完成": "Da Completare",
  "已完成": "Completato",
  "已取消": "Annullato",
  "全部": "Tutti",
  "顾客信息": "Informazioni sul Cliente",
  "用户昵称": "Nome Utente",
  "手机号": "Numero di Telefono",
  "收货地址": "Indirizzo di Consegna",
  "取单号": "Numero di Pick-up dell'Ordine",
  "就餐方式": "Modalità di Consumo",
  "订单号": "Numero dell'Ordine",
  "订单金额": "Importo dell'Ordine",
  "订单优惠": "Sconto dell'Ordine",
  "实付金额": "Importo Effettivo Pagato",
  "支付方式": "Metodo di Pagamento",
  "备注信息": "Note",
  "期望配送时间": "Orario di Consegna Previsto",
  "取餐时间": "Orario di Pick-up",
  "配送费": "Costo di Consegna",
  "退款金额": "Importo del Rimborso",
  "准备中": "In Preparazione",
  "出餐中": "In Cucina",
  "待取餐": "In Attesa del Pick-up",
  "订单信息": "Informazioni sull'Ordine",
  "税费详情": "Dettagli delle Tasse",
  "取消订单": "Annulla Ordine",
  "打印小票": "Stampa Scontrino",
  "出餐": "Servire i Piatti",
  "确认送达": "Confermare la Consegna",
  "退款": "Rimborso",
  "已退款": "Rimborsato",
  "请输入订单号": "Si prega di inserire il numero dell'ordine",
  "至": "A",
  "开始日期": "Data di Inizio",
  "结束日期": "Data di Fine",
  "发送账单": "Invia Fattura",
  "请输入邮箱地址": "Si prega di inserire il tuo indirizzo email",
  "确定要催菜吗?": "Sei sicuro di voler sveltire l'ordine?",
  "确定要完成订单吗?": "Sei sicuro di voler completare l'ordine?",
  "确定要出餐吗?": "Sei sicuro di voler servire i piatti?",
  "确定要发送账单吗?": "Sei sicuro di voler inviare la fattura?",
  "邮箱不能为空": "L'indirizzo email non può essere vuoto",
  "确定要取消订单吗?": "Sei sicuro di voler annullare l'ordine?",
  "是否确认此操作?": "Sei sicuro di voler confermare questa operazione?",
  "上传文件只能是excel格式!": "Il file caricato deve essere in formato Excel!",
  "上传文件大小不能超过 10MB!": "Le dimensioni del file caricato non possono superare 10MB!",
  "正在处理,请等待": "In elaborazione, attendere prego",
  "本次处理失败": "Elaborazione fallita questa volta",
  "总金额": "Importo Totale",
  "可退款金额": "Importo Rimborsabile",
  "请输入退款金额": "Si prega di inserire l'importo del rimborso",
  "超出可退款金额": "Supera l'importo rimborsabile",
  "404错误页面": "Pagina di Errore 404",
  "合计": "Totale",
  "份": "Porzione",
  "余额支付": "Pagamento del Saldo",
  "线下支付(现金支付)": "Pagamento Offline (Pagamento in Contanti)",
  "线下支付(自有微信支付)": "Pagamento Offline (Pagamento WeChat)",
  "线下支付(自有支付宝支付)": "Pagamento Offline (Pagamento Alipay)",
  "线下支付(POS刷卡支付)": "Pagamento Offline (Pagamento con Carta POS)",
  "进行中": "In Corso",
  "待付款": "Pagamento in Sospeso",
  "待配送": "In Attesa di Consegna",
  "配送中": "In Consegna",
  "待接单": "In Attesa di Accettazione",
  "待取货": "In Attesa di Ritiro",
  "已配送": "Consegnato",
  "已收货": "Ricevuto",
  "待收货": "Da Ricevere",
  "待取消": "Da Annullare",
  "会员": "Membro",
  "商家": "Commerciante",
  "供应商": "Fornitore",
  "分销": "Distribuzione",
  "通知": "Notifica",
  "已付款": "Pagato",
  "用户下单": "Ordine dell'Utente",
  "收银台下单": "Ordine al Banco",
  "扫码下单": "Scansionare per Ordinare",
  "团购下单": "Ordine di Gruppo",
  "商城订单": "Ordine del Centro Commerciale",
  "积分商城订单": "Ordine del Centro Punti",
  "余额充值订单": "Ordine di Ricarica del Saldo",
  "购卡订单": "Ordine di Acquisto della Carta",
  "券包订单": "Ordine del Pacchetto Coupon",
  "配送员押金订单": "Ordine del Deposito del Personale di Consegna",
  "团购订单": "Ordine di Acquisto di Gruppo",
  "下单减库存": "Riduzione dell'Inventario all'Ordine",
  "付款减库存": "Riduzione dell'Inventario al Pagamento",
  "商家配送": "Consegna da Parte del Commerciante",
  "外卖配送": "Consegna del Takeaway",
  "到店自提": "Ritiro in Negozio",
  "快递配送": "Consegna Espresso",
  "个人中心": "Centro Personale",
  ...itLocale
}


export default it



// WEBPACK FOOTER //
// ./src/i18n/langs/it.js